export default __webpack_public_path__ + "static/media/sun.93a3e366.svg";